module.exports = __webpack_public_path__ + "img/a15.42fc647b.png";